<template>
  <div>
    <button class="transparent-btn" @click="del">
      刪除
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import apiCoupon from '@/assets/js/api/back/apiCoupon';
export default {
  created() {},
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  methods: {
    del() {
      let vm = this;
      this.$fire({
        title: '確定刪除?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '是',
        cancelButtonText: '否',
      }).then(result => {
        if (result.value === true) {
          const selRows = [this.params.data];
          apiCoupon.defaults.headers.common.Authorization = `Bearer ${this.user.token}`;
          apiCoupon
            .delete(this.params.data.id, {
              uuid: this.user.uuid,
              id: this.params.data,
            })
            .then(res => {
              if (res.status === 200) {
                this.$fire({
                  title: `刪除成功`,
                  type: 'success',
                  timer: 3000,
                });
              }
            })
            .then(() => {
              vm.params.context.componentParent.gridOptions.api.updateRowData({
                remove: selRows,
              });
            })
            .catch(err => {
              this.$fire({
                title: `${err}`,
                type: 'error',
                timer: 3000,
              });
            });

          return;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
